import { userGetByEmailDescription as description } from './description';
import { getByEmail as execute } from './execute';

export { description, execute };
